import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleNegociarClienteEstimacionDesaprobada = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleNegociarClienteEstimacionDesaprobada/tarea-negociar-cliente-estimacion-desaprobada"
    )
);
export function tareaDetalleNegociarClienteEstimacionDesaprobada() {
  return (
    <Route
      path="/tarea-negociar-cliente-estimacion-desaprobada"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleNegociarClienteEstimacionDesaprobada />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
